import { select2RemoteAjax } from './select2_remote';

(function() {
  const globalMatterSearchSelector = '#global-matter-search';

  const initializeGlobalMatterSearch = function() {
    const $select = $(globalMatterSearchSelector);

    if ($select.length === 0 || $select.data('select2')) { return; }

    const isJapanese = (document.documentElement.lang || 'ja').startsWith('ja');

    $select.select2({
      // allowClear は付けない。候補を選ぶと Turbo で遷移してヘッダーが
      // 作り直されるため、残り続ける選択状態がなく × に用がない。120px 幅の
      // うち20pxを食ってプレースホルダーが切れる方が問題になる。
      language: isJapanese ? 'ja' : 'en',
      placeholder: $select.data('placeholder'),
      dropdownCssClass: 'global-matter-search-dropdown',
      // 検索対象は include_completed / include_non_related を有効にしている。
      // トップ画面の検索窓(未完了・自分の関与事件のみ)と違い、終了事件と
      // グループ横断の事件もヒットする。権限は available_matters 側で担保。
      ajax: select2RemoteAjax({
        url: '/matters.json',
        query: params => ({
          search_text_cont_all: params.term,
          include_non_related: true,
          include_completed: true
        })
      }),
      minimumInputLength: 1
    });

    $select.off('select2:select.globalMatterSearch')
      .on('select2:select.globalMatterSearch', function(event) {
        const basePath = $(this).data('matter-base-path');
        Turbo.visit(`${basePath}/${event.params.data.id}`);
      });
  };

  $(document).on('turbo:load', initializeGlobalMatterSearch);

  $(document).on('turbo:before-cache', function() {
    const $select = $(globalMatterSearchSelector);

    if ($select.data('select2')) {
      $select.select2('destroy');
    }
  });

  $(document).on('keydown.globalMatterSearch', function(event) {
    if (event.key !== '/' || event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }

    if ($(event.target).closest('input, textarea, select, [contenteditable]').length > 0) {
      return;
    }

    const $select = $(globalMatterSearchSelector);
    if (!$select.data('select2')) { return; }

    event.preventDefault();
    $select.select2('open');
  });
})();
